import { getSelectorsByUserAgent } from 'react-device-detect';
import { BREAKPOINTS, BREAKPOINT_SIZES } from 'tradera/constants/breakpoints';

export const DEFAULT_USER_AGENT =
    'Mozilla/5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1';

// We have more Google bot mainly uses mobile
const FALLBACK_DEVICE_TYPE = 'mobile';

const DEFAULT_BREAKPOINT_WIDTH = {
    [BREAKPOINTS.XS]: 375, // iPhone 6, 7, 8, X, 11 X/Xs/Pro
    [BREAKPOINTS.SM]: 600, // For most common Tablet width in range
    [BREAKPOINTS.MD]: BREAKPOINT_SIZES.MD.min, // Tablet
    [BREAKPOINTS.LG]: BREAKPOINT_SIZES.LG.min,
    [BREAKPOINTS.XL]: BREAKPOINT_SIZES.XL.min // For most common 1280px desktop
};

const getDeviceTypeFromUserAgent = (userAgent) => {
    const selector = getSelectorsByUserAgent(userAgent || DEFAULT_USER_AGENT);

    if (selector?.deviceType) {
        return selector.deviceType;
    }

    return FALLBACK_DEVICE_TYPE;
};

const getBreakpointFromUserAgent = (userAgent) => {
    const deviceType = getDeviceTypeFromUserAgent(userAgent);

    // For possible values, see: https://github.com/faisalman/ua-parser-js#methods
    switch (deviceType) {
        case 'wearable': // Smartwatch
        case 'mobile':
            return BREAKPOINTS.XS;
        case 'tablet':
            return BREAKPOINTS.MD;
        case 'smarttv':
        case 'console': // Xbox/Playstation
        case 'embedded': // Tesla
        default:
            // Desktop
            return BREAKPOINTS.XL;
    }
};

const getViewportWidthFromUserAgent = (userAgent) => {
    const breakpoint = getBreakpointFromUserAgent(userAgent);
    return DEFAULT_BREAKPOINT_WIDTH[breakpoint];
};

export const getViewportWidth = ({ cookies, headers }) => {
    if (cookies['viewport-width']) {
        return parseInt(cookies['viewport-width'], 10);
    }

    // Note: The viewport-width headers does not follow spec. The width is
    // usually in physical screen pixels instead of viewport CSS pixels.
    const headersViewport = parseInt(
        headers['viewport-width'] || headers['sec-ch-viewport-width'],
        10
    );
    if (headersViewport) {
        return headersViewport;
    }

    const userAgentViewport = getViewportWidthFromUserAgent(
        headers['user-agent']
    );
    return userAgentViewport;
};
